import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';

document.addEventListener("click", async function(e) {
  const atcButton = e.target.closest('button[name="add_custom_bundle"]');
  if (!atcButton) return;

  let handle = atcButton.getAttribute("data-prohandle") || "";
    handle = handle.replace(/-/g, '').toLowerCase(); // match Liquid key

    const bundleData = window.bundleProducts[handle];

    if (!bundleData) {
    console.warn("No bundle data for:", handle);
    return;
    }

    console.log(bundleData);

  //if (!window.bundleProducts) return;

  e.preventDefault();
  console.log("ATC clicked");

  atcButton.classList.add("atc-added");

  // Read properties from button attribute
  const bundleProp = atcButton.getAttribute("data-bundlepro") || "";
  const bundleTitle = atcButton.getAttribute("data-protitle") || "";

  const itemProperties = {};
  if (bundleProp) itemProperties._bundleCount = bundleProp;
  if (bundleTitle) itemProperties._bundleTitle = bundleTitle;

  // 🔥 IMPORTANT:
  // Scope to the form which contains this ATC button (quick view safe)
  const form = atcButton.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
  console.log("form--->", form)

  const selectedRadio = form?.querySelector('input[name^="strength"]:checked');

  if (!selectedRadio) {
    alert("Please select a strength first.");
    atcButton.classList.remove("atc-added");
    return;
  }

  // Normalize
  const selectedValue = selectedRadio.value.replace(/\s+/g, '').toLowerCase();

  // Find matches
  const matchedItems = [];
  bundleData.forEach(product => {
    product.variants.forEach(variant => {
      if (!variant.option1) return;
      if (variant.option1.replace(/\s+/g, '').toLowerCase() === selectedValue) {
        matchedItems.push({
          id: variant.id,
          quantity: 1,
          properties: itemProperties
        });
      }
    });
  });

  if (!matchedItems.length) {
    alert("No matching variants found for " + selectedRadio.value);
    atcButton.classList.remove("atc-added");
    return;
  }

  console.log("Matched:", matchedItems);

  // Add to cart
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: matchedItems })
    }).then(r => r.json());

    console.log("response===>", response);

    atcButton.classList.remove("atc-added");

    // Dispatch Horizon event
    if (typeof CartAddEvent !== "undefined") {
      atcButton.dispatchEvent(
        new CartAddEvent({}, atcButton.id, {
          didError: false,
          source: 'product-form-component-new',
          itemCount: matchedItems.length,
          productId: response.items?.[0]?.product_id || null,
        })
      );
    }

  } catch (error) {
    console.error("Add to cart error:", error);
    alert("Something went wrong adding bundle items!");
    atcButton.classList.remove("atc-added");
  }
});
